
import Button from '../base/Button';

export default function HeroBanner() {
  return (
    <section 
      className="relative h-screen bg-gradient-to-br from-pink-100 via-blue-50 to-teal-50"
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.6)), url('https://static.readdy.ai/image/17bbe7c2712f614d4560f75403a2bffa/0a4c4c277c89be0990118790f76d0dcf.jpeg')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-pink-200/20 via-blue-200/20 to-teal-200/20"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
        <div className="w-full text-center">
          <h1 className="text-6xl md:text-7xl font-light mb-8 leading-tight">
            <span className="block text-gray-800 font-extralight tracking-wide">POCKET WONDERS</span>
            <span className="block text-4xl md:text-5xl bg-gradient-to-r from-pink-500 via-blue-500 to-teal-500 bg-clip-text text-transparent font-normal mt-4">
              口袋珍藏
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-12 text-gray-600 max-w-3xl mx-auto leading-relaxed font-light">
            每一颗宝石，每一件珠宝都是独一无二的艺术品，它并非只是情感的信物，更是属于自己的宠溺。每一次不经意的邂逅，都是生活里最闪耀的回响。
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Button variant="primary" size="lg">
              <span className="mr-2">探索藏品</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Button>
            
            <Button variant="outline" size="lg">
              <span className="mr-2">艺术定制</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-palette-line"></i>
              </div>
            </Button>
          </div>
        </div>
      </div>
      
      {/* Gallery Grid Overlay */}
      <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2">
        <div className="flex space-x-2">
          <div className="w-3 h-3 bg-pink-400 rounded-full"></div>
          <div className="w-3 h-3 bg-blue-400 rounded-full"></div>
          <div className="w-3 h-3 bg-teal-400 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
